<template>
  <div class="search-box" ref="search">
    <div class="title">查询条件</div>

    <div class="search-item">
      <label>开始时间：</label
      ><span @click="chooseTime('start')">{{
        StartTime.length > 0 ? StartTime : "请选择开始时间"
      }}</span>
    </div>
    <div class="search-item">
      <label>截止时间：</label
      ><span @click="chooseTime('end')">{{
        EndTime.length > 0 ? EndTime : "请选择结束时间"
      }}</span>
    </div>
    <div class="search-item">
      <label>选择单位：</label
      ><span
        @click="chooseMenzhen"
        :class="routeQuery.unitproperty == '2' ? 'disabled' : ''"
        >{{ menzhen.length > 0 ? menzhen : "请选择单位" }}</span
      >
    </div>
    <div class="search-item">
      <label>姓&#8195;&#8195;名：</label
      ><input type="text" placeholder="请输入患者姓名（选填）" v-model="name" />
    </div>
    <button class="query-button" @click="Query">查&#8195;询</button>
    <button class="close-button" @click="close">关&#8195;&#8195;闭</button>
    <mt-popup v-model="popupVisible" position="bottom">
      <div class="index-list">
        <div class="index-list-inner">
          <div
            :class="{ 'index-list-item': true, active: menzhen == item.name }"
            v-for="(item, index) in menzhenList"
            :key="index"
            @click="changeMenzhen(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="cancel" @click="popupVisible = false">取消</div>
      </div>
    </mt-popup>
    <mt-datetime-picker
      ref="picker"
      type="datetime"
      month-format="{value} 月"
      date-format="{value} 日"
      hour-format="{value} 时"
      minute-format="{value} 分"
      v-model="pickerValue"
      @confirm="handleConfirm"
    >
    </mt-datetime-picker>
  </div>
</template>

<script>
export default {
  name: "search",
  props: {
    // usercode: {
    //   type: String,
    // },
    // unitproperty:{
    //   type:String
    // },
    routeQuery: {
      type: Object,
    },
    queryData: null,
  },
  data() {
    return {
      menzhenList: [],
      menzhen: "",
      name: "",
      chooseMenzhenCode: "",
      popupVisible: false,
      chooseTimeItem: "",
      StartTime: "",
      StartTimeDate: "",
      EndTime: "",
      EndTimeDate: "",
      pickerValue: "",
    };
  },
  created() {
    if (this.queryData) {
      this._data = this.queryData;
    } else {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth();
      var date = today.getDate();
      console.log(year, month + 1, date);
      var StartTimeDate = new Date(year, month, date, 0, 0, 0);
      var EndTimeDate = new Date(year, month, date, 23, 59, 59);
      this.StartTime = this.getTime(StartTimeDate);
      this.EndTime = this.getTime(EndTimeDate);
      this.StartTimeDate = this.moment(StartTimeDate);
      this.EndTimeDate = this.moment(EndTimeDate);
      if (this.routeQuery.unitproperty == "1") {
        this.$axios
          .get("/api/MyLis/GetAllUnit")
          .then((res) => {
            this.menzhenList = res.data.Table.map((item) => {
              return {
                name: item.unitname,
                code: item.unitcode,
              };
            });
          })
          .catch(() => {
            this.$Toast({
              message: "查询单位数据失败！",
              duration: 1000,
            });
          });
      } else if (this.routeQuery.unitproperty == "2") {
        this.menzhen = this.routeQuery.unitname;
        this.chooseMenzhenCode = this.routeQuery.unitcode;
      } else {
        var params = {
          UserCode: this.routeQuery.usercode,
          Sdate: this.StartTimeDate,
          Edate: this.EndTimeDate,
        };
        this.$axios
          .get("/api/MyLis/SelectUserUnitsForDate", { params: params })
          .then((res) => {
            if (res.data != "-1") {
              this.menzhenList = res.data.Table.map((item) => {
                return {
                  name: item.unitname,
                  code: item.unitcode,
                };
              });
            } else {
              this.$Toast({
                message: "当日无相关单位数据！",
                duration: 1000,
              });
            }
          });
      }
    }
  },
  mounted() {
    this.$refs.search.style.height =
      document.documentElement.clientHeight - 46 + "px";
  },
  methods: {
    close() {
      this.$emit("hideSearch");
    },
    Query() {
      var that = this;
      if (this.chooseMenzhenCode.length > 0) {
        this.$Loading.open("查询中");
        var params = {
          strUnitCode: this.chooseMenzhenCode,
          strSdate: this.StartTimeDate,
          strEdate: this.EndTimeDate,
        };
        var url = "/api/MyLis/GetPatientReportListForUnitCode";
        if (this.name.trim().length > 0) {
          params.strPatName = this.name;
          url = "/api/MyLis/GetPatientReportListForName";
        }
        console.log(params);
        this.$axios
          .get(url, { params: params })
          .then((res) => {
            that.$Loading.close();
            if (res.data != "-1") {
              console.log(res.data);
              that.$Toast({
                message: "查询成功",
                duration: 1000,
              });
              setTimeout(() => {
                that.$emit("querySuccess", {
                  Data: that._data,
                  Result: res.data.Table,
                });
              }, 1000);
            } else {
              that.$Toast({
                message: "没有符合条件的数据",
                duration: 1000,
              });
            }
          })
          .catch(() => {
            that.$Loading.close();
            that.$Toast({
              message: "查询失败",
              duration: 1000,
            });
          });
      } else {
        this.$Toast({
          message: "请选择单位",
          duration: 1000,
        });
      }
    },
    chooseMenzhen() {
      if (["3", "1"].includes(this.routeQuery.unitproperty)) {
        if (this.menzhenList.length > 0) {
          this.popupVisible = true;
        } else {
          this.$Toast({
            message: "当前选择时间段内无单位数据",
            duration: 1000,
          });
        }
      }
    },
    changeMenzhen(obj) {
      this.popupVisible = false;
      this.menzhen = obj.name;
      this.chooseMenzhenCode = obj.code;
    },

    chooseTime(value) {
      this.chooseTimeItem = value;
      switch (value) {
        case "start":
          this.pickerValue = this.StartTimeDate;
          break;
        default:
          this.pickerValue = this.EndTimeDate;
      }
      this.$refs.picker.open();
    },
    handleConfirm(value) {
      console.log(value);
      if (this.chooseTimeItem == "start") {
        if (value > this.EndTimeDate) {
          this.$Toast({
            message: "开始时间不能大于截止时间！",
            duration: 1000,
          });
        } else {
          this.StartTime = this.getTime(value);
          this.StartTimeDate = this.moment(
            new Date(
              value.getFullYear(),
              value.getMonth(),
              value.getDate(),
              0,
              0,
              0
            )
          );
          if (this.routeQuery.unitproperty == "3") {
            this.queryMenzhen();
          }
        }
      } else {
        if (value < this.StartTimeDate) {
          this.$Toast({
            message: "截止时间不能小于开始时间！",
            duration: 1000,
          });
        } else {
          this.EndTime = this.getTime(value);
          this.EndTimeDate = this.moment(
            new Date(
              value.getFullYear(),
              value.getMonth(),
              value.getDate(),
              23,
              59,
              59
            )
          );
          if (this.routeQuery.unitproperty == "3") {
            this.queryMenzhen();
          }
        }
      }
    },
    getTime(value) {
      var year = value.getFullYear();
      var month = value.getMonth() + 1;
      var date = value.getDate();
      var hour = value.getHours();
      var minute = value.getMinutes();
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      var Time = year + "-" + month + "-" + date + " " + hour + ":" + minute;
      return Time;
    },
    moment(value) {
      var year = value.getFullYear();
      var month = value.getMonth() + 1;
      var date = value.getDate();
      var hour = value.getHours();
      var minute = value.getMinutes();
      var second = value.getSeconds();
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minute < 10) minute = "0" + minute;
      if (second < 10) second = "0" + second;
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    queryMenzhen() {
      this.menzhenList = [];
      this.menzhen = "";
      var that = this;
      var params = {
        UserCode: this.routeQuery.usercode,
        Sdate: this.StartTimeDate,
        Edate: this.EndTimeDate,
      };
      console.log(params);
      this.$axios
        .get("/api/MyLis/SelectUserUnitsForDate", { params: params })
        .then((res) => {
          console.log(res.data);
          if (res.data != "-1") {
            this.menzhenList = res.data.Table.map((item) => {
              return {
                name: item.unitname,
                code: item.unitcode,
                method: that.changeMenzhen,
              };
            });
          } else {
            this.$Toast({
              message: "此时间段内无相关单位数据！",
              duration: 1000,
            });
            this.menzhenList = [];
            this.menzhen = "";
          }
        });
    },
  },
};
</script>

<style scoped>
.search-box {
  position: fixed;
  top: 46px;
  width: 100%;
  z-index: 2;
  overflow: hidden;
  font-size: 14px;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 0.3rem;
}
.title {
  font-size: 28px;
  margin-bottom: 0.4rem;
}
.search-item {
  display: flex;
  align-items: center;
  width: 60%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.search-item label {
  display: block;
  width: 40%;
  margin-right: 0.05rem;
}
.search-item span,
.search-item input {
  display: block;
  box-sizing: border-box;
  width: 80%;
  font-size: 14px;
  padding: 6px 5px;
  background-color: #fff;
  border: 1px solid rgb(236, 186, 110);
  border-radius: 4px;
  font-size: 12px;
}
.query-button {
  border: 0;
  width: 80px;
  height: 35px;
  background-color: rgb(82, 182, 240);
  font-size: 14px;
  color: #fff;
  border: 2px solid rgb(236, 186, 110);
  border-radius: 8px;
  text-align: center;
  margin-left: 40%;
}
.query-button:active {
  background-color: rgb(11, 145, 223);
}
.close-button {
  width: 60%;
  height: 50px;
  font-size: 20px;
  color: #fff;
  background-color: rgb(252, 135, 135);
  border: 2px solid #fff;
  border-radius: 8px;
  margin-top: 1.4rem;
}
.close-button:active {
  background-color: rgb(247, 109, 109);
}
.mint-indicator-wrapper {
  z-index: 100;
}
.index-list {
  width: 100vw;
  height: 50vh;
  overflow: hidden;
}
.index-list-inner {
  height: 44vh;
  overflow: hidden;
  overflow-y: scroll;
}
.index-list .cancel,
.index-list-item {
  box-sizing: border-box;
  padding: 10px 10px;
  font-size: 14px;
  text-align: center;
}
.index-list-item:not(:last-child) {
  border-bottom: 0.5px solid #cccccc94;
}
.index-list-item.active {
  background-color: rgb(241 239 239);
}
.index-list .cancel {
  padding: 0;
  height: 6vh;
  border-top: 2px solid #ccc;
  line-height: 6vh;
}
.disabled {
  background: #e1dede;
  color: #b5b2b2;
}
</style>